const ClaimFaq = () => {
  return (
    <>
      <h6>FAQ</h6>
      <div class="accordion mt-3 pb-5" id="accordionFlushExample">
        <div class="accordion-item">
          <h2 class="accordion-header" id="flush-headingOne">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseOne"
              aria-expanded="false"
              aria-controls="flush-collapseOne"
            >
              Car Insurance Claim Process
            </button>
          </h2>
          <div
            id="flush-collapseOne"
            class="accordion-collapse show"
            aria-labelledby="flush-headingOne"
            data-bs-parent="#accordionFlushExample"
          >
            <div class="accordion-body">
              If your vehicle has suffered any damage or loss, the cost of these
              repairs and recovery can be filed under an insurance claim.
              Depending upon your policy, you receive complete or partial
              reimbursement for the expenses incurred towards bringing your
              vehicle back to its original condition. Simply file your claim to
              the company and provide the necessary documents to receive
              remuneration.
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header" id="flush-headingThree">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseThree"
              aria-expanded="false"
              aria-controls="flush-collapseThree"
            >
              How to claim Car Insurance
            </button>
          </h2>
          <div
            id="flush-collapseThree"
            class="accordion-collapse collapse"
            aria-labelledby="flush-headingThree"
            data-bs-parent="#accordionFlushExample"
          >
            <div class="accordion-body">
              You can quickly file a claim by going through these steps:
              <div className="mt-4">
                Step 1: File a claim: You can intimate about a loss using
                “Intimate Claim” section available in your Policy Card. 
                
                <div>Once claim incident details are received, our team will get in touch
                with you over call to understand the claim in detail.</div>

              </div>
              <div className="mt-4">
                Step2: After discussion we intimate the claim to Insurer, you
                will receive a link for self-inspection to your registered
                mobile number.
              </div>
              <div className="mt-4">
                Step 3: Inspection: With the help of the self-inspection form,
                fill in details about the damages to your car on your smartphone
                or tablet. Apart from this, your vehicle will also be inspected
                by one of appointed surveyors.
              </div>
              <div className="mt-4">
                Step 4: Mode of repair: You can choose between receiving
                reimbursement for the damage repairs or making a cashless claim
                through our network of garages.
              </div>
              <div className="mt-4">
                Step 5: Documents needed: Some common documents needed for claim
                settlement are completed claim form, FIR (in certain cases),
                policy documents, identity proofs, address proofs, etc. Keep
                them handy before filing the claim.
              </div>
              <div className="mt-4">
                Step 6: Track your status: You can track the acceptance and
                transaction process online after you complete filing the claim.
              </div>
              <div className="mt-4">
                Step 7: Claim settlement: Insurer will examine the claim to see
                if it meets the guidelines as given in the policy. Once
                approved, they will settle your claim.
              </div>
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="flush-headingFour">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseFour"
              aria-expanded="false"
              aria-controls="flush-collapseFour"
            >
              How to make Car Insurance Cashless Claim
            </button>
          </h2>
          <div
            id="flush-collapseFour"
            class="accordion-collapse collapse"
            aria-labelledby="flush-headingFour"
            data-bs-parent="#accordionFlushExample"
          >
            <div class="accordion-body">
              <div>
                For Cashless Claims, if the vehicle is at Network Garage of Tata
                AIG, they will directly settle the bills with the network
                garage. To make a cashless claim, after you register your claim
                & submit the required documents, take your car for the required
                repairs at the network garage. Once the surveyor confirms the
                damage and determines your liability, your claim gets processed
                and approved. Following this, Insurer directly contact the
                network garage and pay off the dues, which get subtracted from
                your sum insured.
              </div>
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="flush-headingFive">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseFive"
              aria-expanded="false"
              aria-controls="flush-collapseFive"
            >
              How to make Car Insurance Reimbursement Claim
            </button>
          </h2>
          <div
            id="flush-collapseFive"
            class="accordion-collapse collapse"
            aria-labelledby="flush-headingFive"
            data-bs-parent="#accordionFlushExample"
          >
            <div class="accordion-body">
              <div>
                Contrary to cashless claims, in a reimbursement claim, as the
                insured, you pay for the repairs and other damages. Depending
                upon the policy terms and conditions, you can then file for a
                reimbursement claim.
              </div>

              <div>
                In this type of claim, you do not have to mandatorily get your
                car repaired at a registered network garage. You only need to
                provide copies of the bills and other charges to receive the
                claim amount.
              </div>
              <div>
                Once you receive your claim registration number, you can take
                the damaged vehicle to any garage of your choice. Following
                this, you can submit the bills and prepare the other
                documentation for your surveyor to check and confirm your
                liability. If your claim is verified and processed, your
                reimbursement is initiated.
              </div>
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="flush-headingSix">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseSix"
              aria-expanded="false"
              aria-controls="flush-collapseSix"
            >
              What happens if I do not inform my company before I get car
              repairs?{" "}
            </button>
          </h2>
          <div
            id="flush-collapseSix"
            class="accordion-collapse collapse"
            aria-labelledby="flush-headingSix"
            data-bs-parent="#accordionFlushExample"
          >
            <div class="accordion-body">
          

              <div>
                Your claim could get partially or completely rejected if you do
                not inform your company and receive a registration number before
                getting repairs. This is because it goes against the terms and
                conditions of the insurance policy.
              </div>
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="flush-headingSeven">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseSeven"
              aria-expanded="false"
              aria-controls="flush-collapseSeven"
            >
              Documents Required for Car Insurance Claims
            </button>
          </h2>
          <div
            id="flush-collapseSeven"
            class="accordion-collapse collapse"
            aria-labelledby="flush-headingSeven"
            data-bs-parent="#accordionFlushExample"
          >
            <div class="accordion-body">
              <div>
                Several documents are required to ensure your claim gets
                processed and approved successfully. Arranging these documents
                as early as possible is crucial for a smoother process.
              </div>
              <div>
                Here is a list of documents required for car insurance claims:
              </div>
              <div>
                <ul>
                  <li>Claim form signed by the insurer.</li>
                  <li>First Information Report (FIR) in case of an accident</li>
                  <li>
                    No Trace Report from the police and Letter to the RTO if
                    your vehicle is stolen.
                  </li>
                  <li>
                    Legal Notice of the concerned party in case of third-party
                    liabilities
                  </li>
                  <li>Personal details - address and identification proof</li>
                  <li>Hospital bills in case of personal accident claim</li>
                  <li>
                    Repair bills from the garage (in case of reimbursement
                    claims)
                  </li>
                  <li>
                    Registration details of the vehicle, including a copy of the
                    RC with its original keys
                  </li>
                  <li>Copy of the driving license</li>
                  <li>Copy of the original policy</li>
                  <li>Hospital bills for personal accident claims</li>
                  <li>
                    The original estimate, invoice and payment receipt for the
                    repairs done at the network garage
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="flush-headingEight">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseEight"
              aria-expanded="false"
              aria-controls="flush-collapseEight"
            >
              What is the Role of Surveyor
            </button>
          </h2>
          <div
            id="flush-collapseEight"
            class="accordion-collapse collapse"
            aria-labelledby="flush-headingEight"
            data-bs-parent="#accordionFlushExample"
          >
            <div class="accordion-body">
              <div>
              The surveyor plays an important role in car insurance claims and their approval. Here are some of their responsibilities:

              </div>
           
              <div>
                <ul>

                  <li> To thoroughly investigate, manage, validate, and record the damage and losses arising from the accident or theft. They must stick to the rules and regulations as much as possible.</li>
                
          
                  <li>
                  In the event of car loss, the surveyor must remain neutral and impartial. They must maintain absolute confidentiality.
                  </li>
                  <li>They must personally perform spot surveys and determine whether the case falls under excess insurance or under-insurance.</li>
                  <li>Surveyors must determine and declare all conflicts of interest.</li>
                  <li>
                  They must resolve all the queries of the insurer and the insured with regards to the claim.
                  </li>
                  <li>
                  They must also comment on the depreciation, its applicability, quantum, and percentage.
                  </li>
                  <li>They must give advice to the insurer about the minimisation of loss for safety and security and also find ways to control the loss wherever possible.</li>
                 
                </ul>
              </div>
            </div>
          </div>
        </div>
        
      </div>
    </>
  );
};

export default ClaimFaq;
